import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import authService from '../services/authService';

function SSOCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [message, setMessage] = useState('Completing sign-in…');
  const ran = useRef(false);

  useEffect(() => {
    // React StrictMode runs effects twice in dev; the state nonce is single-use.
    if (ran.current) return;
    ran.current = true;

    (async () => {
      try {
        const returnTo = authService.handleSSOCallback(window.location.hash);
        // Drop the token from the address bar and browser history.
        window.history.replaceState(null, '', window.location.pathname);
        const user = await refreshUser();
        if (!user) {
          throw new Error('SSO sign-in could not be completed. Please try again.');
        }
        navigate(returnTo, { replace: true });
      } catch (err) {
        authService.logout();
        setMessage('Sign-in failed.');
        const detail = err.response?.data?.error || err.message || 'SSO sign-in failed';
        navigate(`/login?error=${encodeURIComponent(detail)}`, { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="page">
      <header>
        <img className="logo" src="/logo.png" alt="Stewart Valuation Intelligence" />
        <h1>Remote Inspection</h1>
      </header>
      <main className="main">
        <div className="card" style={{ maxWidth: '450px', textAlign: 'center' }}>
          <h2>Signing in</h2>
          <p style={{ color: '#64748b' }}>{message}</p>
        </div>
      </main>
    </div>
  );
}

export default SSOCallback;
